import React from 'react'
import Lottie from "lottie-react";
import Loader from "../../assets/Json/Hand.json"
export const LoadingScreen = () => {
  return (
    <>
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"80vh"}} >
    <Lottie animationData={Loader} loop={true}   />
    </div>
    </>
  )
}
